import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import '../styles/ConfirmEmail.css'

function ConfirmEmail() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Checking...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get("token");
    const email = searchParams.get("email");

    if (!token || !email) {
      setStatus("❌ Invalid confirmation link.");
      setLoading(false);
      return;
    }

    fetch(`${API_BASE_URL}/Auth/confirm-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, token }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const errorData = await res.text();
          throw new Error(errorData);
        }
        return res.text();
      })
      .then((data) => {
        setStatus("✅ " + data);
      })
      .catch((err) => setStatus("❌ " + err.message))
      .finally(() => setLoading(false));
  }, []); // فقط یک بار اجرا شود

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Email Confirmation</h2>
      <p>{loading ? "🔄 Confirming email..." : status}</p>
    </div>
  );
}

export default ConfirmEmail;
